import {msalConfig, loginRequest, accessRequest, funcApiKey} from './authConfig';
import {PublicClientApplication } from '@azure/msal-browser';
import service from '../utility/service';
import {store} from '../index';

export const msalInstance = new PublicClientApplication(msalConfig);

  const INITIAL_STATE = {
    fetching: false,
    isLoggedIn: false,
    account: undefined,
  };
  const types = {
    RECEIVED_AUTH: 'orb/auth/RECEIVED_AUTH',
  };
  
  export default function reducer(state = INITIAL_STATE, action = {}) {
    switch (action.type) {
        case types.RECEIVED_AUTH:
            return Object.assign({}, state, {
            fetching: action.loggedAccount.fetching,
            isLoggedIn: action.loggedAccount.isLoggedIn,
            account: action.loggedAccount.account,
            });
      default:
        return state;
    }
  }
  reducer.types = types;
  reducer.initialState = INITIAL_STATE;

  function receivedAuth(loggedAccount) {
    return {
      type: types.RECEIVED_AUTH,
      loggedAccount
    };
  }

  function fetchAuth () {
      return async (dispatch) => {
        authenticate(dispatch);
    };
  }  

  function authenticate(dispatch)
  {
      msalInstance.handleRedirectPromise().then(response => {
        const account = getAccount();
        if (!account) 
          msalInstance.loginRedirect(loginRequest);
        else
          dispatch(receivedAuth({fetching: false, isLoggedIn: true, account: account}));
      })
      .catch(error => {
        if (error) {
          console.error("Authenticaiton error - " + error);
        }
      });
  }

  function getAccount() {
    const currentAccounts = msalInstance.getAllAccounts();
    if (currentAccounts.length === 0) {
        console.log("No accounts");
        return undefined;
    }
    if (currentAccounts.length >= 1)
        return currentAccounts[0];
  }
 
  function shouldFetchAuth(state) {
    return !state.fetching && !state.isLoggedIn;
  }
  
  export function fetchAuthIfNeeded() {
    return (dispatch, getState) => {
      if (shouldFetchAuth(getState().auth)) {
        return dispatch(fetchAuth());
      }
      return Promise.resolve();
    };
  }

  function acquireToken() {
        const accReq = {...accessRequest, account: store.getState().auth.account}
        return msalInstance.acquireTokenSilent(accReq).catch(error => {
            console.warn("Silent token acquisition failed, acquiring token using Popup" + error);
          return msalInstance.acquireTokenPopup(accReq).then(tokenResponse => {
              return tokenResponse;
          }).catch(error => {
              console.error(error);
          });
        });
  }

  service.interceptors.request.use(
    async (config) => {
        const result = await acquireToken();
        const token = result.accessToken;
        msalConfig.lastToken = token; // temp bodge for Excel download
        config.headers = {
          'Authorization': token ? `Bearer ${token}` :'',
          'x-functions-key': funcApiKey,
         }
        return config;
      },
      error => {
        Promise.reject(error)
    }
  );


// WEBPACK FOOTER //
// ./src/provider/reducer.js